import { gql } from '@apollo/client'
import { Banner, Button, StarActiveIcon } from '@farol-ds/react'
import { useEffect } from 'react'

export interface TemporaryOfferBannerDataProps {
  title: string
  subtitle: string
  cta: {
    link: string
    label: string
  }
}

export type TemporaryOfferBannerProps = {
  data: TemporaryOfferBannerDataProps
  className?: string
  onCtaClick(): void
  onShow(): void
  onClose(): void
}

export function TemporaryOfferBanner({
  data: {
    title,
    subtitle,
    cta: { link, label },
  },
  onCtaClick,
  onShow,
  onClose,
  className,
}: TemporaryOfferBannerProps) {
  useEffect(() => {
    onShow()
    // eslint-disable-next-line
  }, [])

  return (
    <div>
      <Banner defaultVisible level="standard" type="info" className={className}>
        <Banner.Content>
          <Banner.Title>
            <Banner.Icon>
              <StarActiveIcon />
            </Banner.Icon>
            {title}
          </Banner.Title>
          <Banner.Description>{subtitle}</Banner.Description>
        </Banner.Content>
        <Banner.IconClose onClick={onClose} />
        <Banner.Action>
          <Button onClick={onCtaClick} asChild>
            <a href={link}>{label}</a>
          </Button>
        </Banner.Action>
      </Banner>
    </div>
  )
}

TemporaryOfferBanner.fragments = {
  temporaryOfferBanner: gql`
    fragment TemporaryOfferBannerFragment on TemporaryOfferBanner {
      title
      subtitle
      cta {
        link
        label
      }
    }
  `,
}
